import React from "react";
import "../styles/Books.css";

const BookCard = ({ book }) => {
  if (!book) return <div>Book data not available.</div>;

  const showAuthors = (authors) => {
    return authors.map((author, index) => <p key={index}>{author.name}</p>);
  };

  return (
    <article className="book-card" aria-label={`Book titled ${book.title}`}>
      <h2>{book.title}</h2>
      <img
        src={book.formats["image/jpeg"]}
        alt={`Cover of ${book.title}`}
        loading="lazy"
      />
      <div>
        <h3>Authors:</h3>
        <p>{showAuthors(book.authors)}</p>
      </div>
      <div>
        <h3>Subjects:</h3>
        <p>{book.subjects.join(", ")}</p>
      </div>
      <div>
        <h3>Bookshelves:</h3>
        <p>{book.bookshelves.join(", ")}</p>
      </div>
      <div>
        <h3>Languages:</h3>
        <p>{book.languages.join(", ")}</p>
      </div>
    </article>
  );
};

export default BookCard;
